import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

import { HubComments } from '@/components/HubComments';
import { GetRepoResponse } from '@/types/schema';

import RepoContent from './RepoContent';
import RepoDetail from './RepoDetail';
import RepoDetailCommits from './RepoDetailCommits';

export const PromptView = ({
  inHub,
  showProxyProviderWarning,
  setShowProxyProviderWarningModal,
  repoObj,
}: {
  inHub: boolean;
  showProxyProviderWarning: boolean;
  setShowProxyProviderWarningModal: (show: boolean) => void;
  repoObj: GetRepoResponse;
}) => {
  return (
    <PanelGroup
      autoSaveId="hub-repo-detail"
      direction="horizontal"
      className="flex-grow"
    >
      <Panel className="!overflow-visible bg-secondary">
        <RepoContent
          inHub={inHub}
          showProxyProviderWarning={showProxyProviderWarning}
          setShowProxyProviderWarningModal={setShowProxyProviderWarningModal}
        />
      </Panel>
      <PanelResizeHandle className="group relative -mt-4 flex items-stretch text-secondary data-[resize-handle-active]:text-brand-green-400">
        <div className="w-[1px] bg-secondary" />
        <div className="absolute inset-y-0 w-[2px] bg-current opacity-0 transition-all group-hover:opacity-100" />
      </PanelResizeHandle>
      <Panel defaultSize={20} className="self-stretch">
        <div className="flex flex-col justify-start">
          <RepoDetail repoObj={repoObj} inHub={inHub} />
          <div className="border-t border-tertiary" />
          <RepoDetailCommits inHub={inHub} />
          <div className="border-t border-tertiary" />
          <HubComments />
        </div>
      </Panel>
    </PanelGroup>
  );
};
